import React, {useEffect, useState} from "react";
import moment from "moment";
import gql from 'graphql-tag';

import { calloutContainer, 
    image, 
    title, 
    imageContainer, 
    buttonContainer, 
    buttonImage, 
    tagsContainer,
    tagText,
    primaryTag,
    buttonLeft,
    buttonRight,
    buttonText,
    icon,
    infoText,
    infoValue,
    infoContainer } from "./callout.module.css";

import { UserMarker } from "./markers";
import {ReactComponent as ChatButton} from "../../../assets/chatMarker.svg";
import {ReactComponent as LocationButton} from "../../../assets/locationMarker.svg";
import {ReactComponent as MemberIcon} from "../../../assets/member.svg";
import {ReactComponent as ViewsIcon} from "../../../assets/views.svg";
import { client } from "../../../App";
import { getProfileViews } from "../../../graphql/queries";

export default ({ name, tags, imageURL, createdAt, profileId, tagFeatured }) => {

    const [profileViews, setProfileViews] = useState(0)
    useEffect(() => {
        async function getProfileViewsOnLoad() {
            if (profileId) {
                const views = await client.query({
                    query: gql(getProfileViews),
                    variables: {
                        profileId
                    },
                    fetchPolicy: "no-cache"
                }) 

                setProfileViews(views.data.getProfileViews)
            }
        }
        getProfileViewsOnLoad()
    })

    return (
        <div className={calloutContainer}>
            <div className={imageContainer}>
                {
                    imageURL ? <img className={image} src={imageURL} alt={name} /> : <UserMarker className={image} name={name} />
                }
            </div>
            <div className={title}>{name}</div>
            <div className={primaryTag}>
                {tagFeatured}
            </div>
            <div className={tagsContainer}>
                <p className={tagText}>
                {
                    tags 
                    ?                             
                    tags.map((tag, i) => (
                        i + 1 === tags.length ? tag.trim() : tag + ", "
                    ))               
                    : null
                }
                </p>
            </div>
            <div className={buttonContainer}>
                <a href="http://web.pod.io" className={buttonLeft}>
                    <LocationButton className={buttonImage}/>
                    <span className={buttonText}>Location</span>
                </a>  
                <a href="http://web.pod.io" className={buttonRight}>
                    <ChatButton className={buttonImage}/>
                    <span className={buttonText}>Chat</span>
                </a>                    
            </div>
            <div style={{marginTop: "2vh"}}>
                <div className={infoContainer}>
                    <MemberIcon className={icon}/>
                    <span className={infoText}>Member Since: </span>
                    <span className={infoValue}>{
                        moment(createdAt).format("MMM YYYY")
                    }</span>
                </div>
                <div className={infoContainer}>
                    <ViewsIcon className={icon}/>
                    <span className={infoText}>Profile Views: </span>
                    <span className={infoValue}>{profileViews}</span>                   
                </div>
            </div>
        </div>
    )
    
}